/* vitae · sky theme driver. Loaded (not deferred) from layout/theme.liquid, right after vitae-sky.css,
   so the band is set before the first paint.
   Sets <html data-band> + --sky from the visitor's clock every 15 s and copies the resulting tokens
   into Concept's RGB-triple variables, so the vendor sections follow the same colours.
   Bands (ward poster): den 6–18 · vecer 18–20 · pred 20–21 · noc 21–6.
   Preview: ?sky=den|vecer|pred|noc, ?sky=13.5 (an hour) or ?sky=auto in the URL sets or clears a preview
   for the browser tab. The time-of-day scene in the menu (snippets/vitae-sky-scene.liquid +
   assets/vitae-sky-scene.js) drives previewHour(). */
(function () {
  "use strict";
  var html = document.documentElement;
  if (!(window.CSS && CSS.supports && CSS.supports("color", "color-mix(in oklab, red, blue)"))) return;

  var BANDS = ["den", "vecer", "pred", "noc"];
  var STOPS = [[0, "#8E2418"], [4, "#B8321B"], [5, "#D9531E"], [6, "#F0A03A"], [7, "#F5D26B"], [8, "#A9CDEB"], [9, "#6FB1E8"], [12, "#5AA7EA"], [15, "#6FB1E8"], [17, "#A9CDEB"], [18, "#F5C24A"], [19, "#F0862E"], [20, "#D9531E"], [21, "#B8321B"], [23, "#8E2418"]];
  var PREVIEW_HOUR = { noc: 23.5, pred: 20.5, vecer: 19, den: 13 };
  var KEY = "vt_sky_preview";

  function h2r(h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; }
  function skyAt(h) {
    var a = STOPS[0], b = STOPS[STOPS.length - 1];
    for (var i = 0; i < STOPS.length - 1; i++) if (h >= STOPS[i][0] && h <= STOPS[i + 1][0]) { a = STOPS[i]; b = STOPS[i + 1]; break; }
    var u = a[0] === b[0] ? 0 : (h - a[0]) / (b[0] - a[0]), ca = h2r(a[1]), cb = h2r(b[1]);
    return "rgb(" + ca.map(function (v, j) { return Math.round(v + (cb[j] - v) * u); }).join(",") + ")";
  }
  function bandAt(h) { return h >= 21 || h < 6 ? "noc" : h >= 20 ? "pred" : h >= 18 ? "vecer" : "den"; }

  /* ── Concept's colour variables are "R G B" triples; feed them from the computed tokens ── */
  var CONCEPT = [
    ["--color-base-background", "--bg"], ["--color-base-text", "--ink"], ["--color-base-highlight", "--orange"],
    ["--color-base-button", "--orange"], ["--color-base-button-text", "--on-orange"],
    ["--color-drawer-background", "--bg"], ["--color-drawer-text", "--ink"],
    ["--color-drawer-button-background", "--orange"], ["--color-drawer-button-text", "--on-orange"],
    ["--color-placeholder", "--surface-2"], ["--color-price", "--ink-strong"],
    ["--color-sale-price", "--orange"], ["--color-sale-tag", "--orange"], ["--color-sale-tag-text", "--on-orange"],
    ["--color-rating", "--orange"], ["--color-info-text", "--orange"], ["--color-info-background", "--orange-soft"],
    ["--color-success-background", "--surface"], ["--color-error-background", "--surface"]
  ];
  function c255(x) { return Math.max(0, Math.min(255, Math.round(x))); }
  function gam(x) { return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055); }
  /* computed colour (#hex, rgb(), color(srgb …) or oklab()) → "R G B" */
  function triple(v) {
    v = String(v || "").trim(); var m, p;
    if (v.charAt(0) === "#") { if (v.length === 4) v = "#" + v[1] + v[1] + v[2] + v[2] + v[3] + v[3]; return h2r(v).join(" "); }
    if ((m = v.match(/^rgba?\(([^)]+)\)/))) { p = m[1].split(/[\s,\/]+/).map(parseFloat); return [c255(p[0]), c255(p[1]), c255(p[2])].join(" "); }
    if ((m = v.match(/^color\(srgb\s+([^)]+)\)/))) { p = m[1].split(/[\s\/]+/).map(parseFloat); return [c255(p[0] * 255), c255(p[1] * 255), c255(p[2] * 255)].join(" "); }
    if ((m = v.match(/^oklab\(([^)]+)\)/))) {
      p = m[1].split(/[\s\/]+/); var Lk = parseFloat(p[0]) / (/%$/.test(p[0]) ? 100 : 1), A = parseFloat(p[1]), B = parseFloat(p[2]);
      var l = Math.pow(Lk + 0.3963377774 * A + 0.2158037573 * B, 3), md = Math.pow(Lk - 0.1055613458 * A - 0.0638541728 * B, 3), s = Math.pow(Lk - 0.0894841775 * A - 1.2914855480 * B, 3);
      return [c255(gam(4.0767416621 * l - 3.3077115913 * md + 0.2309699292 * s)), c255(gam(-1.2684380046 * l + 2.6097574011 * md - 0.3413193965 * s)), c255(gam(-0.0041960863 * l - 0.7034186147 * md + 1.7076147010 * s))].join(" ");
    }
    return null;
  }
  /* browsers without @property hand back the raw token ("color-mix(…)"): resolve it on a hidden probe */
  var probe = null;
  function resolve(v) {
    if (!probe) { probe = document.createElement("i"); probe.hidden = true; probe.setAttribute("aria-hidden", "true"); html.appendChild(probe); }
    probe.style.color = ""; probe.style.color = v;
    return probe.style.color ? getComputedStyle(probe).color : "";
  }
  var lastCopy = "";
  function copyToConcept() {
    var cs = getComputedStyle(html), out = [];
    CONCEPT.forEach(function (pair) { var v = cs.getPropertyValue(pair[1]), t = triple(v) || triple(resolve(v)); if (t) out.push(pair[0] + ":" + t); });
    var sig = out.join(";");
    if (sig === lastCopy) return;
    lastCopy = sig;
    out.forEach(function (d) { var i = d.indexOf(":"); html.style.setProperty(d.slice(0, i), d.slice(i + 1)); });
    tintBrowser(cs);
  }
  /* the phone's top bar and browser chrome follow the page: <meta name="theme-color"> = the current --bg */
  var themeMeta = null;
  function tintBrowser(cs) {
    var t = triple(cs.getPropertyValue("--bg")) || triple(resolve(cs.getPropertyValue("--bg")));
    if (!t) return;
    var hex = "#" + t.split(" ").map(function (v) { v = (+v).toString(16); return v.length < 2 ? "0" + v : v; }).join("");
    if (!themeMeta) {
      themeMeta = document.querySelector('meta[name="theme-color"]');
      if (!themeMeta) { themeMeta = document.createElement("meta"); themeMeta.name = "theme-color"; (document.head || html).appendChild(themeMeta); }
    }
    if (themeMeta.content !== hex) themeMeta.setAttribute("content", hex);
  }
  /* the tokens fade for 2 s on <html>; follow them frame by frame so Concept's parts fade too */
  var raf = 0, until = 0;
  function follow() { copyToConcept(); if (performance.now() < until) raf = requestAnimationFrame(follow); }
  function startFollow() { until = performance.now() + 2300; cancelAnimationFrame(raf); raf = requestAnimationFrame(follow); }

  /* preview: null (follow the clock) or { band, hour }. Kept for the browser tab in sessionStorage as a
     band name ("noc") or an hour ("h:13.25"); the time-of-day scene in the menu scrubs by the hour. */
  var pv = null;
  function parsePv(v) {
    if (!v) return null;
    if (BANDS.indexOf(v) >= 0) return { band: v, hour: PREVIEW_HOUR[v] };
    var m = /^h:(\d+(?:\.\d+)?)$/.exec(v); if (!m) return null;
    var h = Math.max(0, Math.min(23.99, parseFloat(m[1]))); return { band: bandAt(h), hour: h };
  }
  try {
    var q = new URLSearchParams(location.search).get("sky");
    if (q) { if (parsePv(q) || /^\d/.test(q)) sessionStorage.setItem(KEY, /^\d/.test(q) ? "h:" + q : q); else sessionStorage.removeItem(KEY); }
    pv = parsePv(sessionStorage.getItem(KEY));
  } catch (e) { pv = null; }

  var lastSig = "";
  function liveHour() { var n = new Date(); return n.getHours() + n.getMinutes() / 60; }
  function apply(instant) {
    var h = pv ? pv.hour : liveHour(), b = pv ? pv.band : bandAt(h), sky = skyAt(h);
    var first = !html.hasAttribute("data-band"), sig = b + "|" + sky;
    if (sig !== lastSig) {
      lastSig = sig;
      html.setAttribute("data-band", b);
      html.style.setProperty("--sky", sky);
      html.style.setProperty("--band-c", "var(--c-" + b + ")");
      if (first || instant) { cancelAnimationFrame(raf); copyToConcept(); } else startFollow();
    }
    try { document.dispatchEvent(new CustomEvent("vitae:sky", { detail: { band: b, sky: sky, hour: h, auto: !pv, preview: pv ? pv.band : null } })); } catch (e) {}
  }
  function store(v, persist) { try { if (v && persist !== false) sessionStorage.setItem(KEY, v); else sessionStorage.removeItem(KEY); } catch (e) {} }
  /* band preview; persist: false keeps it on this page only (the Apolinář band buttons) */
  function setPreview(b, persist) {
    b = BANDS.indexOf(b) >= 0 ? b : null;
    if (!b && !pv && html.hasAttribute("data-band")) return;
    pv = b ? { band: b, hour: PREVIEW_HOUR[b] } : null;
    store(b, persist);
    apply();
  }
  /* hour preview (0–24); instant: skip the 2 s fade while someone drags the time (call settle() after) */
  function previewHour(h, opts) {
    opts = opts || {};
    h = ((+h % 24) + 24) % 24;
    pv = { band: bandAt(h), hour: h };
    store("h:" + h.toFixed(2), opts.persist);
    if (opts.instant) html.classList.add("vt-sky-instant");
    apply(!!opts.instant);
  }
  function settle() { html.classList.remove("vt-sky-instant"); }
  function boot() { apply(); setInterval(function () { if (!pv) apply(); }, 15000); }

  apply(); // before first paint
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  window.vitaeSky = { at: skyAt, band: bandAt, preview: setPreview, previewHour: previewHour, settle: settle,
    current: function () { return { band: html.getAttribute("data-band"), preview: pv ? pv.band : null, hour: pv ? pv.hour : liveHour(), auto: !pv }; } };
})();
